import { ProductItem, ProductItemFormData } from "../types/products";
import { ProductItemStatus } from "../enums/productItems";

export const SampleProductItems: ProductItem[] = [
  // Items for PROD-001 (BoomHigh Vape Cartridge)
  {
    id: "ITEM-001",
    productId: "PROD-001",
    totalQuantity: 1,
    remainingQuantity: 1,
    state: ProductItemStatus.IN_STOCK,
    createdAt: "2025-01-10T10:00:00Z",
    updatedAt: "2025-01-10T10:00:00Z",
    lastUpdatedBy: "admin@kivunova.com",
    purchasePrice: 15.0,
    salesPrice: 20.5,
    weight: 0.15,
    height: 4.2,
    width: 1.8,
    color: "Silver",
    thickness: 0.5,
    packSize: "10 pcs",
    expirationDate: "2026-12-31",
    productionDate: "2024-11-01",
    lotNumber: "LOT-2024-111",
    storeId: "STORE-001",
    companyId: "COMP-001",
    createdBy: "admin@kivunova.com"
  },
  {
    id: "ITEM-002",
    productId: "PROD-001",
    totalQuantity: 1,
    remainingQuantity: 1,
    state: ProductItemStatus.IN_STOCK,
    createdAt: "2025-01-10T10:01:00Z",
    updatedAt: "2025-01-10T10:01:00Z",
    lastUpdatedBy: "admin@kivunova.com",
    purchasePrice: 15.0,
    salesPrice: 20.5,
    weight: 0.15,
    height: 4.2,
    width: 1.8,
    color: "Silver",
    thickness: 0.5,
    packSize: "10 pcs",
    expirationDate: "2026-12-31",
    productionDate: "2024-11-01",
    lotNumber: "LOT-2024-111",
    storeId: "STORE-001",
    companyId: "COMP-001",
    createdBy: "admin@kivunova.com"
  },
  {
    id: "ITEM-003",
    productId: "PROD-001",
    totalQuantity: 1,
    remainingQuantity: 0,
    state: ProductItemStatus.SOLD,
    createdAt: "2025-01-10T10:02:00Z",
    updatedAt: "2025-02-15T14:30:00Z",
    lastUpdatedBy: "cashier@kivunova.com",
    purchasePrice: 15.0,
    salesPrice: 20.5,
    weight: 0.15,
    height: 4.2,
    width: 1.8,
    color: "Silver",
    thickness: 0.5,
    packSize: "10 pcs",
    expirationDate: "2026-12-31",
    productionDate: "2024-11-01",
    lotNumber: "LOT-2024-111",
    storeId: "STORE-001",
    companyId: "COMP-001",
    createdBy: "admin@kivunova.com"
  },
  {
    id: "ITEM-004",
    productId: "PROD-001",
    totalQuantity: 1,
    remainingQuantity: 1,
    state: ProductItemStatus.RESERVED,
    createdAt: "2025-01-10T10:03:00Z",
    updatedAt: "2025-02-20T09:15:00Z",
    lastUpdatedBy: "manager@kivunova.com",
    purchasePrice: 15.0,
    salesPrice: 20.5,
    weight: 0.15,
    height: 4.2,
    width: 1.8,
    color: "Silver",
    thickness: 0.5,
    packSize: "10 pcs",
    expirationDate: "2026-12-31",
    productionDate: "2024-11-01",
    lotNumber: "LOT-2024-111",
    storeId: "STORE-001",
    companyId: "COMP-001",
    createdBy: "admin@kivunova.com"
  },
  {
    id: "ITEM-005",
    productId: "PROD-001",
    totalQuantity: 1,
    remainingQuantity: 1,
    state: ProductItemStatus.DAMAGED,
    createdAt: "2025-01-10T10:04:00Z",
    updatedAt: "2025-02-18T11:20:00Z",
    lastUpdatedBy: "manager@kivunova.com",
    purchasePrice: 15.0,
    weight: 0.15,
    height: 4.2,
    width: 1.8,
    color: "Silver",
    thickness: 0.5,
    packSize: "10 pcs",
    expirationDate: "2026-12-31",
    productionDate: "2024-11-01",
    lotNumber: "LOT-2024-111",
    storeId: "STORE-001",
    companyId: "COMP-001",
    createdBy: "admin@kivunova.com"
  },
  // Items for PROD-002 (EcoSmart LED Bulb)
  {
    id: "ITEM-006",
    productId: "PROD-002",
    totalQuantity: 1,
    remainingQuantity: 1,
    state: ProductItemStatus.IN_STOCK,
    createdAt: "2025-03-12T08:00:00Z",
    updatedAt: "2025-03-12T08:00:00Z",
    lastUpdatedBy: "admin@kivunova.com",
    purchasePrice: 2.5,
    salesPrice: 3.99,
    weight: 0.2,
    height: 5.5,
    width: 2.2,
    color: "White",
    thickness: 1.1,
    packSize: "6 pcs",
    expirationDate: "2030-01-01",
    productionDate: "2025-03-10",
    lotNumber: "LOT-2025-033",
    storeId: "STORE-002",
    companyId: "COMP-001",
    createdBy: "admin@kivunova.com"
  },
  {
    id: "ITEM-007",
    productId: "PROD-002",
    totalQuantity: 1,
    remainingQuantity: 1,
    state: ProductItemStatus.IN_STOCK,
    createdAt: "2025-03-12T08:01:00Z",
    updatedAt: "2025-03-12T08:01:00Z",
    lastUpdatedBy: "admin@kivunova.com",
    purchasePrice: 2.5,
    salesPrice: 3.99,
    weight: 0.2,
    height: 5.5,
    width: 2.2,
    color: "White",
    thickness: 1.1,
    packSize: "6 pcs",
    expirationDate: "2030-01-01",
    productionDate: "2025-03-10",
    lotNumber: "LOT-2025-033",
    storeId: "STORE-002",
    companyId: "COMP-001",
    createdBy: "admin@kivunova.com"
  },
  {
    id: "ITEM-008",
    productId: "PROD-002",
    totalQuantity: 1,
    remainingQuantity: 1,
    state: ProductItemStatus.IN_STOCK,
    createdAt: "2025-03-12T08:02:00Z",
    updatedAt: "2025-03-12T08:02:00Z",
    lastUpdatedBy: "admin@kivunova.com",
    purchasePrice: 2.5,
    salesPrice: 3.99,
    weight: 0.2,
    height: 5.5,
    width: 2.2,
    color: "White",
    thickness: 1.1,
    packSize: "6 pcs",
    expirationDate: "2030-01-01",
    productionDate: "2025-03-10",
    lotNumber: "LOT-2025-033",
    storeId: "STORE-002",
    companyId: "COMP-001",
    createdBy: "admin@kivunova.com"
  },
  {
    id: "ITEM-009",
    productId: "PROD-002",
    totalQuantity: 1,
    remainingQuantity: 0,
    state: ProductItemStatus.SOLD,
    createdAt: "2025-03-12T08:03:00Z",
    updatedAt: "2025-03-15T16:45:00Z",
    lastUpdatedBy: "cashier@kivunova.com",
    purchasePrice: 2.5,
    salesPrice: 3.99,
    weight: 0.2,
    height: 5.5,
    width: 2.2,
    color: "White",
    thickness: 1.1,
    packSize: "6 pcs",
    expirationDate: "2030-01-01",
    productionDate: "2025-03-10",
    lotNumber: "LOT-2025-033",
    storeId: "STORE-002",
    companyId: "COMP-001",
    createdBy: "admin@kivunova.com"
  },
  {
    id: "ITEM-010",
    productId: "PROD-002",
    totalQuantity: 1,
    remainingQuantity: 1,
    state: ProductItemStatus.IN_STOCK, // Changed from IN_TRANSIT (not in PRD enum)
    createdAt: "2025-03-12T08:04:00Z",
    updatedAt: "2025-03-20T10:00:00Z",
    lastUpdatedBy: "logistics@kivunova.com",
    purchasePrice: 2.5,
    salesPrice: 3.99,
    weight: 0.2,
    height: 5.5,
    width: 2.2,
    color: "White",
    thickness: 1.1,
    packSize: "6 pcs",
    expirationDate: "2030-01-01",
    productionDate: "2025-03-10",
    lotNumber: "LOT-2025-033",
    storeId: "STORE-002",
    companyId: "COMP-001",
    createdBy: "admin@kivunova.com"
  },
  // Items for PROD-003 (KivuNova Gym Bottle)
  {
    id: "ITEM-011",
    productId: "PROD-003",
    totalQuantity: 1,
    remainingQuantity: 1,
    state: ProductItemStatus.IN_STOCK,
    createdAt: "2025-02-05T09:00:00Z",
    updatedAt: "2025-02-05T09:00:00Z",
    lastUpdatedBy: "sam@kivunova.com",
    purchasePrice: 8.5,
    salesPrice: 12.0,
    weight: 0.35,
    height: 10.0,
    width: 3.5,
    color: "Black",
    thickness: 0.3,
    packSize: "1 pc",
    productionDate: "2025-01-15",
    lotNumber: "LOT-2025-010",
    storeId: "STORE-003",
    companyId: "COMP-002",
    createdBy: "sam@kivunova.com"
  },
  {
    id: "ITEM-012",
    productId: "PROD-003",
    totalQuantity: 1,
    remainingQuantity: 1,
    state: ProductItemStatus.IN_STOCK,
    createdAt: "2025-02-05T09:01:00Z",
    updatedAt: "2025-02-05T09:01:00Z",
    lastUpdatedBy: "sam@kivunova.com",
    purchasePrice: 8.5,
    salesPrice: 12.0,
    weight: 0.35,
    height: 10.0,
    width: 3.5,
    color: "Black",
    thickness: 0.3,
    packSize: "1 pc",
    productionDate: "2025-01-15",
    lotNumber: "LOT-2025-010",
    storeId: "STORE-003",
    companyId: "COMP-002",
    createdBy: "sam@kivunova.com"
  },
  {
    id: "ITEM-013",
    productId: "PROD-003",
    totalQuantity: 1,
    remainingQuantity: 1,
    state: ProductItemStatus.IN_STOCK, // Changed from RETURNED (not in PRD enum, using IN_STOCK)
    createdAt: "2025-02-05T09:02:00Z",
    updatedAt: "2025-02-25T13:30:00Z",
    lastUpdatedBy: "customer-service@kivunova.com",
    purchasePrice: 8.5,
    salesPrice: 12.0,
    weight: 0.35,
    height: 10.0,
    width: 3.5,
    color: "Black",
    thickness: 0.3,
    packSize: "1 pc",
    productionDate: "2025-01-15",
    lotNumber: "LOT-2025-010",
    storeId: "STORE-003",
    companyId: "COMP-002",
    createdBy: "sam@kivunova.com"
  }
];

export const DefaultProductItemFormValues: ProductItemFormData = {
  productId: "",
  storeId: "",
  totalQuantity: 1,
  purchasePrice: undefined,
  salesPrice: undefined,
  minSalesPrice: undefined,
  variationName: "",
  weight: undefined,
  height: undefined,
  width: undefined,
  color: "",
  thickness: undefined,
  packSize: "",
  material: "",
  packagingType: "",
  expirationDate: "",
  productionDate: "",
  lotNumber: ""
};
